import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface UserAdminElement {
    _id: string;
    username: string;
    email: string;
    password: string;
    enabled: boolean;
    roles: string;
}

interface UserAdminState {
    elements: UserAdminElement[];
}

const initialState: UserAdminState = {
    elements: []
};

export const UserAdmin = createSlice({
    name: "userAdmin",
    initialState,
    reducers: {

        getAllElementByTenant: (state) => {
        },

        getAllElementSuccessByTenant: (state, actions: PayloadAction<UserAdminElement[]>) => {
            state.elements = actions.payload
        },

        getAllElementErrorByTenant: (state) => {},

        getSpecificUser: (state) => {
        },
        getSpecificUserSuccess: (state, action: PayloadAction<UserAdminElement>) => {
            const updatedUser = action.payload;
            const index = state.elements.findIndex(user => user._id === updatedUser._id);
            if (index !== -1) {
                state.elements[index] = updatedUser;
            } else {
                state.elements.push(updatedUser);
            }
        },
        getSpecificUserError: (state, action: PayloadAction<string>) => {

        },

        saveElement: (state, action: PayloadAction<UserAdminElement>) => {},
        saveElementSuccess: (state, action: PayloadAction<UserAdminElement>) => {
            state.elements.push(action.payload);
        },
        saveElementError: (state, action: PayloadAction<UserAdminElement>) => {},

        updateElement: (state, actions: PayloadAction<UserAdminElement>) => {},
        updateElementSuccess: (state, actions: PayloadAction<UserAdminElement>) => {
            let index = state.elements.findIndex(element => element._id === actions.payload._id)
            state.elements[index] = actions.payload
        },
        updateElementError:(state, action: PayloadAction<UserAdminElement>) => {},

        deleteElement: (state, action: PayloadAction<{ id: string, callback: () => void }>) => {},

        deleteElementSuccess: (state, action: PayloadAction<string>) => {
            state.elements = state.elements.filter(el => el._id !== action.payload);
        },
        deleteElementError: () => {},

    },
});

export const {
    saveElementError,
    saveElement,
    getAllElementByTenant,
    updateElementError,
    updateElement,
    deleteElementError,
    deleteElement,
    getAllElementSuccessByTenant,
    getAllElementErrorByTenant,
    getSpecificUser,
    getSpecificUserSuccess,
    getSpecificUserError,
    saveElementSuccess,
    updateElementSuccess,
    deleteElementSuccess,
} = UserAdmin.actions;

export default UserAdmin.reducer;
